import request from 'superagent'

import {getHeadersWithGRPC} from '@/services/api'
import {myAccessApi} from '@/modules/ITSM/api/generate-itsm-api-url'

export const getMyAccess = async () => {
  return await request
    .options(myAccessApi().get)
    .send({})
    .set(getHeadersWithGRPC())
}
